import React from 'react';

/**
 * Contact Page 
 */
const ContactPage = () => (
   <section className="contact page-section">
      <div className="page-container">
         <div className="page-title-wrapper">
            <h2 className="page-title">Contact.</h2>
         </div>
         <p className="page-subtitle">"tincidunt vel pulvinar at"</p>
         <p className="contact__copy">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed maximus, augue porttitor pulvinar efficitur, turpis nulla rhoncus libero, non ultrices nisl nisi quis ante. Aenean dictum nisl metus, id convallis nulla bibendum sed. Nullam iaculis lorem sed lectus efficitur dignissim. Praesent vitae malesuada elit, a posuere felis. Praesent a fermentum mi. Nulla ac ultricies diam. Vestibulum interdum facilisis est. Integer nec convallis metus. Fusce sed sapien nulla.
         </p>
         {/* <ul className="contact-list">
				<li><a href="mailto:lorem@torontolive.com" className="contact-list__link">lorem@torontolive.com</a></li>	
				<li><a href="tel:8888888888" className="contact-list__link">1-888-888-8888</a></li>
			</ul> */}
      </div>
   </section>
);

export default ContactPage;